import React from 'react';
import PageHeader from '../../../../components/PageHeader';
import FilterDropDown from '../../../../components/FilterDropDown';
import Datatable from '../../../../components/DataTable';
import { Box, Button, IconButton, Stack, TablePagination, Typography } from '@mui/material';
import TablePaginationActions from '../../../../components/TablePaginationActions';
import { useState } from 'react';
import { useTheme } from '@emotion/react';
import { useSelector } from 'react-redux';
import { CancelToken } from 'apisauce';
import { useEffect } from 'react';
import appapi from '../../../../api/apiClient';
import moment from 'moment';
import { checkPermission } from '../../../../redux/features/authSlice';
import { useTranslation } from 'react-i18next';

const screeningStatus = {
  pending: '#BA9B1D1A',
  approved: '#00A63226',
  rejected: '#C220201A',
  inprogress: '#006DFF1A',
  pendingColor: '#BA9B1D',
  approvedColor: '#00A632',
  rejectedColor: '#C22020',
  inprogressColor: '#006DFF',
};

export default function TraderList({ showTraderRequest }) {
  const theme = useTheme();
  const text = theme.palette.primary.text;
  const textLight = theme.palette.primary.textLight;
  const { t } = useTranslation();

  const { companyDetails } = useSelector((state) => state.auth);
  const settingPermission = useSelector((state) => checkPermission(state, 'Settings', 'Manage Company Profile'));

  const [payload, setPayload] = useState({
    page: 1,
    limit: 10,
    filter: null,
    totalLength: 0,
    paginationPage: 0,
    field: '_id',
    sortOrder: 'desc',
  });

  const [tradersList, setTradersList] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  let source = CancelToken.source();

  const columns = [
    {
      id: 0,
      header: '#',
      accessor: 'Sno',
      width: '8%',
    },
    {
      id: 1,
      header: 'Trader',
      accessor: 'displayName',
      width: '60%',
      capitalize: true,
    },
    {
      id: 2,
      header: 'Date',
      accessor: 'date',
      width: '15%',
    },
    {
      id: 3,
      header: 'Status',
      accessor: 'status',
      width: '17%',
      jcc: true,
      Cell: (item) => (
        <div className="flex !justify-center">
          <Stack
            justifyContent={'center'}
            alignItems={'center'}
            className="fw-regular fs-12 ff-Roboto h-[28px] w-[100px] px-[10px] rounded-[16px] capitalize"
            sx={{ backgroundColor: screeningStatus[item?.screeningStatus], color: screeningStatus[`${item?.screeningStatus}Color`] }}
          >
            {item?.screeningStatus === 'inprogress' ? t('In Progress') : t(`${item?.screeningStatus}`)}
          </Stack>
        </div>
      ),
    },
  ];

  const handleChangePage = (event, newPage) => {
    setPayload((prevState) => ({ ...prevState, page: newPage + 1, paginationPage: newPage, filter: payload.filter }));
  };

  const handleChangeRowsPerPage = (event) => {
    setPayload((prev) => ({ ...prev, limt: parseInt(event.target.value, 10), paginationPage: 1, page: 1, filter: payload.filter }));
  };

  //search filter
  const handleSearchEmit = (search) => {
    setPayload((prevState) => ({ ...prevState, limt: 10, paginationPage: 0, page: 1, filter: search }));
  };

  const handleGetTrader = async () => {
    setIsLoading(true);
    source.cancel();
    source = CancelToken.source();
    const response = await appapi.get(
      `/company-management/allRequests/${companyDetails?._id}`,
      {
        pageNumber: payload.page,
        filter: payload.filter ? payload.filter : null,
        pageSize: payload.limit,
        field: payload.field,
        sortOrder: payload.sortOrder,
      },
      { cancelToken: source.token },
    );
    if (response.ok) {
      const data = response.data;
      if (data.status === '7400') {
        let userData = data?.response;
        userData.map((item, index) => {
          item.Sno = payload.limit * (payload.page === 1 ? 0 : payload.page - 1) + index + 1;
          item.date = moment(item.date).format('DD-MM-YYYY');
          return item;
        });
        setTradersList(userData);
        setPayload((prev) => ({ ...prev, totalLength: data?.length, paginationPage: payload.page === 1 ? 0 : payload.page - 1 }));
        setIsLoading(false);
      } else {
        setTradersList([]);
        setPayload((prev) => ({ ...prev, totalLength: 0, paginationPage: 0 }));
        setIsLoading(false);
      }
    } else {
      setTradersList([]);
      setPayload((prev) => ({ ...prev, totalLength: 0, paginationPage: 1 }));
      // setIsLoading(false);
    }
  };

  useEffect(() => {
    handleGetTrader();
    return () => {
      if (source) {
        source.cancel();
      }
    };
    // eslint-disable-next-line
  }, [payload.page, payload.filter, payload.field, payload.sortOrder]);

  return (
    <Stack
      flex={1}
      style={{ backgroundColor: '#F2F3F580', borderRadius: '8px', borderColor: '#8993AC26', borderWidth: '1px', minHeight: '70vh' }}
    >
      <Stack style={{ width: '100%', backgroundColor: '#F2F3F580' }}>
        <PageHeader
          tableType={'2'}
          handleOnSearchEmit={(search) => {
            handleSearchEmit(search);
          }}
          headerColor={'#F2F3F580'}
        >
          <Stack
            direction="row"
            style={{ width: '100%', backgroundColor: '#F2F3F580' }}
          >
            <Stack style={{ paddingLeft: '16px' }}>
              <Typography
                className="fs-16 ff-Roboto fw-regular"
                color={text}
              >
              {t('KYC verification status')}
              </Typography>
              <Typography
                className="fs-12 ff-Roboto fw-regular"
                color={textLight}
              >
                {t('List of all the traders who want to trade with you')}
              </Typography>
            </Stack>
            <Stack flexGrow={1} />
            {companyDetails?.traderListAccess === '1' && settingPermission.addAccess && companyDetails?.euaTrading && <Button
              onClick={() => {
                showTraderRequest();
              }}
              className=""
            >
              {/* <PersonAddIcon style={{ transform: 'scale(1.143)', color: theme.palette.primary.main, width: '12px', height: '12px' }} /> */}
              <Typography
                color={theme.palette.primary.main}
                className="fs-14 ff-Roboto fw-medium"
                textTransform={'uppercase'}
              >
                {t('Add trader')}
              </Typography>
            </Button>}
          </Stack>
        </PageHeader>
        <Stack
          style={{ backgroundColor: '#8993AC26', height: '1px', marginBottom: '10px', marginTop: '10px', opacity: 0.7 }}
          className="mx-[15px]"
        />
        <Stack
          flex={1}
          style={{ backgroundColor: '#f8f9fa' }}
        >
          <div className="relative pl-[16px]  bg-[#f8f9fa] inputFormStyle overflow-auto">
            <Stack className="">
              <Datatable
                themeType={2}
                columns={columns}
                data={tradersList}
                isLoading={isLoading}
                tableBodyBgColor={'#F2F3F580'}
                tableHeadBgColor={'#F2F3F580'}
              />
            </Stack>
            {payload?.totalLength > 10 && (
              <Box
                className="flex  justify-end items-center h-[56px] w-[98%] p-[5px] bg-[#F2F3F580]  mr-[10px] rounded-b-lg"
                sx={{ borderTop: '1px solid rgba(224, 224, 224, 1)' }}
              >
                <TablePagination
                  sx={{ borderBottom: 0 }}
                  rowsPerPageOptions={[]}
                  count={payload.totalLength ? payload.totalLength : 0}
                  rowsPerPage={payload.limit ? payload.limit : 10}
                  page={payload.paginationPage ? payload.paginationPage : 0}
                  onPageChange={handleChangePage}
                  onRowsPerPageChange={handleChangeRowsPerPage}
                  ActionsComponent={TablePaginationActions}
                />
              </Box>
            )}
          </div>
        </Stack>
      </Stack>
    </Stack>
  );
}
